import React, { useState, useEffect } from 'react';
import Icon from '../components/Icon';
import DateTimeField from '../components/DateTimeField';
import { useNavigate, useLocation } from 'react-router-dom';
import API from '../services/api';
import { useLanguage } from '../context/LanguageContext';
import AdmissionForm from './AdmissionForm';
import OtaqSecici from '../components/OtaqSecici';
import './NewRequest.css';

const DEPT_ICONS = {
  IT: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>,
  HR: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="9" cy="7" r="3"/><path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2"/><path d="M16 3.13a4 4 0 010 7.75M21 21v-2a4 4 0 00-3-3.87"/></svg>,
  FINANCE: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M12 1v22M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>,
  SUPPLY: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"/></svg>,
  ADMISSION: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14,2 14,8 20,8"/><path d="M12 18v-6M9 15l3 3 3-3"/></svg>,
  ACADEMIC: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M12 3L2 8l10 5 10-5-10-5z"/><path d="M2 8v6"/><path d="M6 10.5v5a6 3 0 0012 0v-5"/></svg>,
  HIK: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>,
  MAINTENANCE: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>,
};

const DEPT_COLORS = {
  IT: '#0369a1', HR: '#7c3aed', FINANCE: '#059669', SUPPLY: '#d97706',
  ADMISSION: '#dc2626', ACADEMIC: '#007c82', HIK: '#6b7280', MAINTENANCE: '#ea580c',
};

const DEPT_DESCS = {
  IT: 'Texniki problem, avadanlıq, proqram təminatı',
  HR: 'İşburaxma, məzuniyyət, arayış, şikayət',
  FINANCE: 'Əmək haqqı, avans, pay slip, maliyyə',
  SUPPLY: 'Tələbnamə (anbar), alış sifarişi',
  ADMISSION: 'Şagird qəbulu, sənəd tələbi',
  ACADEMIC: 'Akademik müraciətlər',
  HIK: 'Ərizə, təqdimat',
  MAINTENANCE: 'Təmir işləri, elektrik, santexnika',
};

const IT_CAT_KEYS = ['Avadanlıq','Proqram təminatı','Şəbəkə','Giriş / İcazə','E-poçt','Printer','Telefon','Digər'];
const IT_OS = ['Windows 10','Windows 11','macOS','Linux','Android','iOS','Other'];

export default function NewRequest() {
  const { t, lang } = useLanguage();
  const navigate = useNavigate();
  const IT_CATEGORIES = [
    { v:'Avadanlıq',         l:t('requests.catEquipment') },
    { v:'Proqram təminatı',  l:t('requests.catSoftware') },
    { v:'Şəbəkə',            l:t('requests.catNetwork') },
    { v:'Giriş / İcazə',     l:t('requests.catAccess') },
    { v:'E-poçt',            l:t('requests.catEmail') },
    { v:'Printer',           l:t('requests.catPrinter') },
    { v:'Telefon',           l:t('requests.catPhone') },
    { v:'Digər',             l:t('requests.catOther') },
  ];
  const PRIORITY = {
    urgent: { label: t('requests.priorityUrgent'), color: '#dc2626', sla: t('requests.slaUrgent') },
    high:   { label: t('requests.priorityHigh'),   color: '#d97706', sla: t('requests.slaHigh') },
    medium: { label: t('requests.priorityMedium'), color: '#2563eb', sla: t('requests.slaMedium') },
    low:    { label: t('requests.priorityLow'),    color: '#6b7280', sla: t('requests.slaLow') },
  };
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDept, setSelectedDept] = useState(null);

  // Form state
  const [reqTypes, setReqTypes] = useState([]);
  const [newType, setNewType] = useState('');
  const [newTitle, setNewTitle] = useState('');
  const [newDesc, setNewDesc] = useState('');
  const [newPriority, setNewPriority] = useState('medium');
  // IT
  const [newCategory, setNewCategory] = useState('');
  const [newDevice, setNewDevice] = useState('');
  const [newRoom, setNewRoom] = useState('');
  const [newOS, setNewOS] = useState('');
  const [newErrorMsg, setNewErrorMsg] = useState('');
  // Finance
  const [newInstallMonths, setNewInstallMonths] = useState('');
  const [newPaySlipMonth, setNewPaySlipMonth] = useState('');
  // HR
  const [newAbsType, setNewAbsType] = useState('');
  const [newFamReason, setNewFamReason] = useState('');
  const [newEduDoc, setNewEduDoc] = useState('');
  const [newEduFiles, setNewEduFiles] = useState([]);
  const [newLeaveStart, setNewLeaveStart] = useState('');
  const [newLeaveEnd, setNewLeaveEnd] = useState('');
  const [newLeaveExpl, setNewLeaveExpl] = useState('');
  // Publication request fields
  const [newPubDate, setNewPubDate] = useState('');
  const [newPubFile, setNewPubFile] = useState(null);
  const [newPubFileUrl, setNewPubFileUrl] = useState('');
  const [newPubUploading, setNewPubUploading] = useState(false);
  // Maintenance fields
  const [maintLocation, setMaintLocation] = useState('');
  const [maintRoom, setMaintRoom] = useState('');
  const [maintAccess, setMaintAccess] = useState('anytime');
  const [maintPhotoUrl, setMaintPhotoUrl] = useState('');
  const [maintPhotoName, setMaintPhotoName] = useState('');
  const [maintPhotoUploading, setMaintPhotoUploading] = useState(false);

  // --- Forma 1: mülki-hüquq müqaviləsinin bağlanmasına dair sorğu (Hüquq və Komplayens) ---
  const me = JSON.parse(localStorage.getItem('user') || '{}');
  const [lgRequester, setLgRequester] = useState(me.name || '');   // adı, soyadı, atasının adı
  const [lgPosition, setLgPosition]   = useState(me.position || ''); // vəzifəsi
  // 2. Müqavilənin bağlanıldığı digər tərəf
  const [lgParty, setLgParty]         = useState('');  // hüquqi/fiziki şəxsin tam adı
  const [lgContact, setLgContact]     = useState('');  // məlumatlı şəxsin adı, soyadı
  const [lgPhone, setLgPhone]         = useState('');
  const [lgEmail, setLgEmail]         = useState('');
  // 3. Müqavilənin şərtləri
  const [lgSubject, setLgSubject]     = useState('');  // predmeti (xidmət növü)
  const [lgPrice, setLgPrice]         = useState('');  // qiyməti və ödəniş şərtləri
  const [lgStart, setLgStart]         = useState('');  // bağlanma tarixi
  const [lgDuration, setLgDuration]   = useState('');  // müddəti
  const [lgSpecial, setLgSpecial]     = useState('');  // xüsusi şərt

  const [submitting, setSubmitting] = useState(false);

  const location = useLocation();

  useEffect(() => {
    API.get('/departments').then(r => {
      setDepartments(r.data);
      setLoading(false);
      // Auto-select department from navigation state OR URL query
      const st = location.state;
      const params = new URLSearchParams(window.location.search);
      const deptFromUrl = params.get('dept');

      if (st?.deptId) {
        const dept = r.data.find(d => d.id === st.deptId || d.code === st.deptCode);
        if (dept) { resetForm(); setSelectedDept(dept); }
      } else if (st?.deptCode) {
        const dept = r.data.find(d => d.code === st.deptCode);
        if (dept) { resetForm(); setSelectedDept(dept); }
      } else if (deptFromUrl) {
        const dept = r.data.find(d => d.code === deptFromUrl);
        if (dept) { resetForm(); setSelectedDept(dept); }
      }
      window.history.replaceState({}, '');
    }).catch(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (!selectedDept) return;
    if (selectedDept.code === 'SUPPLY') return;
    API.get('/departments/' + selectedDept.id + '/types').then(r => setReqTypes(r.data)).catch(() => {});
  }, [selectedDept]);

  const isIT = selectedDept?.code === 'IT';
  const isHR = selectedDept?.code === 'HR';
  const isFinance = selectedDept?.code === 'FINANCE';
  const isMaintenance = selectedDept?.code === 'MAINTENANCE';
  const isLegal = selectedDept?.code === 'LEGAL';

  const resetForm = () => {
    setNewType(''); setNewTitle(''); setNewDesc(''); setNewPriority('medium');
    setNewCategory(''); setNewRoom(''); setNewDevice(''); setNewOS(''); setNewErrorMsg('');
    setNewInstallMonths(''); setNewPaySlipMonth('');
    setNewAbsType(''); setNewFamReason(''); setNewEduDoc('');
    setNewLeaveStart(''); setNewLeaveEnd(''); setNewLeaveExpl('');
    setNewPubDate(''); setNewPubFile(null); setNewPubFileUrl('');
    setMaintLocation(''); setMaintRoom(''); setMaintAccess('anytime');
    setMaintPhotoUrl(''); setMaintPhotoName('');
  };

  const handleMaintPhotoUpload = async (file) => {
    if (!file) return;
    setMaintPhotoUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await API.post('/chat/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setMaintPhotoUrl(res.data.url || '');
      setMaintPhotoName(file.name);
    } catch (e) {
      alert(t('maintenance.uploadFailed'));
    } finally { setMaintPhotoUploading(false); }
  };

  // Detect when a "Nəşr / Çap" request type is selected
  const isPublicationType = !!reqTypes.find(rt =>
    rt.id === parseInt(newType) && /(Nəşr|Çap|nesh?r|publication|publish)/i.test(rt.name || '')
  );

  // Min publication date = 2 days from today
  const minPubDate = (() => {
    const d = new Date(); d.setDate(d.getDate() + 2);
    return d.toISOString().slice(0, 10);
  })();

  const handlePubFileUpload = async (file) => {
    if (!file) return;
    setNewPubFile(file);
    setNewPubUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await API.post('/chat/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setNewPubFileUrl(res.data.url || '');
    } catch (e) {
      alert(t('publication.uploadFailed'));
      setNewPubFile(null); setNewPubFileUrl('');
    } finally { setNewPubUploading(false); }
  };

  const handleSelect = (dept) => {
    if (dept.code === 'SUPPLY') {
      navigate('/procurement', { state: { openNew: true } });
      return;
    }
    resetForm();
    setSelectedDept(dept);
  };

  const isAdmission = selectedDept?.code === 'ADMISSION';
  const [admStep, setAdmStep] = useState(1);

  const cameFromDept = !!location.state?.deptCode || !!location.state?.deptId || !!new URLSearchParams(window.location.search).get('dept');

  // Köhnə keçid: /requests/new?dept=ADMISSION artıq işlədilmir —
  // qəbul müraciətləri Şagird Qeydiyyatı bölməsinə köçürülüb.
  useEffect(() => {
    const q = new URLSearchParams(window.location.search).get('dept');
    if (q === 'ADMISSION' || location.state?.deptCode === 'ADMISSION') {
      navigate('/enrollment', { replace: true });
    }
  }, []);   // eslint-disable-line react-hooks/exhaustive-deps

  // If user lands on /requests/new without any dept context, send them to /requests
  useEffect(() => {
    if (loading) return;
    if (!selectedDept && !cameFromDept) {
      navigate('/requests', { replace: true });
    }
  }, [loading, selectedDept, cameFromDept, navigate]);

  const handleBack = () => {
    // Inside AdmissionForm step 2, step back to category cards (step 1)
    if (isAdmission && admStep === 2) {
      setAdmStep(1);
      return;
    }
    // Otherwise, always go back to /requests
    navigate('/requests');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      if (isHR) {
        if (!newAbsType || !newLeaveStart || !newLeaveEnd) { alert('Növ, başlama və bitmə tarixini doldurun'); setSubmitting(false); return; }
        if (newAbsType === 'education' && newEduDoc === 'yes' && !newEduFiles.length) {
          alert('Sənəd var seçmisiniz — zəhmət olmasa sənədin özünü də əlavə edin.'); setSubmitting(false); return;
        }
        const lv = await API.post('/leave', {
          absence_type: newAbsType,
          family_reason: newAbsType === 'family' ? newFamReason : undefined,
          education_has_doc: newAbsType === 'education' ? (newEduDoc === 'yes' ? 1 : 0) : undefined,
          explanation: newLeaveExpl,
          start_date: newLeaveStart, end_date: newLeaveEnd,
        });
        if (newEduFiles.length && lv.data?.id) {
          const fd = new FormData();
          newEduFiles.forEach(f => fd.append('files', f));
          await API.post('/leave/' + lv.data.id + '/attachments', fd,
            { headers: { 'Content-Type': 'multipart/form-data' } });
          setNewEduFiles([]);
        }
      } else {
        if (!newTitle.trim()) { setSubmitting(false); return; }
        if (isPublicationType) {
          if (!newPubDate) { alert(t('publication.errorDateRequired')); setSubmitting(false); return; }
          const today = new Date(); today.setHours(0,0,0,0);
          const pub = new Date(newPubDate); pub.setHours(0,0,0,0);
          const diffDays = Math.round((pub - today) / 86400000);
          if (diffDays < 2) {
            if (!window.confirm(t('publication.confirmLessThan2Days'))) { setSubmitting(false); return; }
          }
        }
        const custom = {};
        if (newCategory) custom.category = newCategory;
        if (newRoom) custom.room = newRoom;
        if (newDevice) custom.device = newDevice;
        if (newOS) custom.os = newOS;
        if (newErrorMsg) custom.error_msg = newErrorMsg;
        if (newInstallMonths) custom.installment_months = newInstallMonths;
        if (newPaySlipMonth) custom.pay_slip_month = newPaySlipMonth;
        if (newPubDate) custom.publication_date = newPubDate;
        if (newPubFileUrl) custom.material_url = newPubFileUrl;
        if (newPubFile?.name) custom.material_name = newPubFile.name;
        if (isMaintenance) {
          if (!maintLocation.trim()) { alert(t('maintenance.errorLocation')); setSubmitting(false); return; }
          custom.location = maintLocation.trim();
          if (maintRoom.trim()) custom.room = maintRoom.trim();
          custom.access_time = maintAccess;
          if (maintPhotoUrl) { custom.photo_url = maintPhotoUrl; custom.photo_name = maintPhotoName; }
        }
        if (isLegal) {
          if (!lgParty.trim() || !lgSubject.trim() || !lgPrice.trim()) {
            alert(t('legal.errorRequired')); setSubmitting(false); return;
          }
          custom.form = 'legal_contract_f1';            // Forma 1
          custom.requester_full = lgRequester.trim();
          custom.requester_position = lgPosition.trim();
          custom.party_name = lgParty.trim();
          if (lgContact.trim()) custom.party_contact = lgContact.trim();
          if (lgPhone.trim())   custom.party_phone = lgPhone.trim();
          if (lgEmail.trim())   custom.party_email = lgEmail.trim();
          custom.contract_subject = lgSubject.trim();
          custom.contract_price = lgPrice.trim();
          if (lgStart)            custom.contract_start = lgStart;
          if (lgDuration.trim())  custom.contract_duration = lgDuration.trim();
          if (lgSpecial.trim())   custom.contract_special = lgSpecial.trim();
        }
        await API.post('/requests', {
          department_id: selectedDept.id,
          request_type_id: newType || null,
          title: newTitle.trim(),
          description: newDesc.trim(),
          priority: (isFinance || isLegal) ? 'medium' : newPriority,
          custom_fields: Object.keys(custom).length ? custom : null,
        });
      }
      navigate('/requests');
    } catch (err) {
      alert(err.response?.data?.error || 'Xəta baş verdi');
    } finally { setSubmitting(false); }
  };

  const deptColor = DEPT_COLORS[selectedDept?.code] || '#007c82';

  return (
    <div className="new-req-page">
      <div className="new-req-header">
        <button className="new-req-back" onClick={handleBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
        </button>
        <div>
          <h2>{selectedDept ? (lang === 'en' ? t('departments.' + selectedDept.name, selectedDept.name) : selectedDept.name) : t('newRequest.title')}</h2>
        </div>
      </div>

      {/* Department Selection - only show if not coming from dept card */}
      {!selectedDept && !cameFromDept && (
        loading ? (
          <div style={{ textAlign:'center', padding:60, color:'#9ca3af' }}>{t('common.loading')}</div>
        ) : (
          <div className="dept-grid">
            {departments.map(dept => {
              const icon = DEPT_ICONS[dept.code] || DEPT_ICONS.IT;
              const color = DEPT_COLORS[dept.code] || '#007c82';
              const desc = DEPT_DESCS[dept.code] || 'Ümumi müraciətlər';
              return (
                <div key={dept.id} className="dept-card" onClick={() => handleSelect(dept)} style={{ '--dept-color': color }}>
                  <div className="dept-card-icon" style={{ color }}>{icon}</div>
                  <div className="dept-card-info">
                    <div className="dept-card-name">{dept.name}</div>
                    <div className="dept-card-desc">{desc}</div>
                  </div>
                  <div className="dept-card-stats">
                    {dept.type_count > 0 && <span>{dept.type_count} növ</span>}
                    {dept.member_count > 0 && <span>{dept.member_count} işçi</span>}
                  </div>
                  <div className="dept-card-arrow">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6"/></svg>
                  </div>
                </div>
              );
            })}
          </div>
        )
      )}

      {/* Loading when coming from dept but not loaded yet */}
      {!selectedDept && cameFromDept && loading && (
        <div style={{textAlign:'center',padding:60,color:'#9ca3af'}}>{t('common.loading')}</div>
      )}

      {/* Admission form */}
      {selectedDept && isAdmission && (
        <AdmissionForm onBack={handleBack} step={admStep} setStep={setAdmStep} />
      )}

      {/* Generic form */}
      {selectedDept && !isAdmission && (
        <form onSubmit={handleSubmit} className="new-req-form">
          {isHR ? (
            <>
              <label className="nrf-label">{t('requests.fieldLeaveType')}</label>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:7 }}>
                {[
                  { v:'medical',   l:t('requests.leaveMedical'),   icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M3 7V17a2 2 0 002 2h14a2 2 0 002-2V7"/><path d="M1 7h22"/><path d="M8 3h8a2 2 0 012 2v2H6V5a2 2 0 012-2z"/><path d="M12 11v6M9 14h6"/></svg>, d:t('requests.leaveMedicalDesc') },
                  { v:'family',    l:t('requests.leaveFamily'),    icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="8" cy="6" r="2.5"/><circle cx="16" cy="6" r="2.5"/><path d="M3 20v-2a4 4 0 014-4h2a4 4 0 014 4v2"/><path d="M15 14a4 4 0 014 4v2"/></svg>, d:t('requests.leaveFamilyDesc') },
                  { v:'personal',  l:t('requests.leavePersonal'),  icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="7" r="4"/><path d="M5.5 21v-2a6.5 6.5 0 0113 0v2"/></svg>, d:t('requests.leavePersonalDesc') },
                  { v:'education', l:t('requests.leaveEducation'), icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M12 3L2 8l10 5 10-5-10-5z"/><path d="M2 8v6"/><path d="M6 10.5v5a6 3 0 0012 0v-5"/></svg>, d:t('requests.leaveEducationDesc') },
                  { v:'other',     l:t('requests.leaveOther'),     icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14,2 14,8 20,8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>, d:t('requests.leaveOtherDesc') },
                ].map(it => (
                  <label key={it.v} className={'nrf-type-card' + (newAbsType===it.v?' sel':'')} style={{'--sel-color': deptColor}}>
                    <input type="radio" style={{display:'none'}} checked={newAbsType===it.v}
                      onChange={() => { setNewAbsType(it.v); setNewFamReason(''); setNewEduDoc(''); }} />
                    <span className="nrf-type-icon">{it.icon}</span>
                    <span className="nrf-type-name">{it.l}</span>
                    <span className="nrf-type-desc">{it.d}</span>
                  </label>
                ))}
              </div>

              {newAbsType === 'family' && (
                <>
                  <label className="nrf-label">Ailə səbəbi *</label>
                  <select className="nrf-input" value={newFamReason} onChange={e => setNewFamReason(e.target.value)} required>
                    <option value="">Seçin</option>
                    <option value="death">Birinci dərəcəli qohumun vəfatı</option>
                    <option value="own_wedding">Özünün toyu</option>
                    <option value="child_wedding">Oğul / qızın toyu</option>
                  </select>
                </>
              )}
              {newAbsType === 'education' && (
                <>
                  <label className="nrf-label">Müvafiq sənəd varmı?</label>
                  <select className="nrf-input" value={newEduDoc}
                          onChange={e => { setNewEduDoc(e.target.value); if (e.target.value !== 'yes') setNewEduFiles([]); }}>
                    <option value="">Seçin</option>
                    <option value="yes">Bəli, sənəd var</option>
                    <option value="no">Xeyr, izahat tələb olunur</option>
                  </select>
                </>
              )}
              {newAbsType === 'education' && newEduDoc === 'yes' && (
                <>
                  {/* Arayışın özü — rəhbər, HR və direktor ərizənin içində açır */}
                  <label className="nrf-label">Sənədi yükləyin *</label>
                  <input className="nrf-input" type="file" multiple
                         accept=".pdf,.jpg,.jpeg,.png,.heic,.webp,.doc,.docx"
                         onChange={e => setNewEduFiles(Array.from(e.target.files || []).slice(0, 3))} />
                  <div style={{ fontSize:'0.72rem', color:'#9ca3af', marginTop:4 }}>
                    PDF, şəkil və ya Word. Ən çoxu 3 fayl, hər biri 15 MB-a qədər.
                  </div>
                </>
              )}

              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                <div><label className="nrf-label">Başlama tarixi *</label>
                  <DateTimeField value={newLeaveStart} onChange={setNewLeaveStart} required /></div>
                <div><label className="nrf-label">Bitmə tarixi *</label>
                  <DateTimeField value={newLeaveEnd} onChange={setNewLeaveEnd} required /></div>
              </div>

              {['medical','personal','education','other'].includes(newAbsType) && (
                <>
                  <label className="nrf-label">{newAbsType === 'medical' ? 'Qeyd (istəyə bağlı)' : 'İzahat *'}</label>
                  <textarea className="nrf-input" value={newLeaveExpl} onChange={e => setNewLeaveExpl(e.target.value)}
                    required={newAbsType !== 'medical'} rows={3} placeholder="İşburaxma səbəbini izah edin..." />
                </>
              )}
            </>
          ) : (
            <>
              {reqTypes.length > 0 && (
                <>
                  <label className="nrf-label">{t('requests.formTypeLabel')}</label>
                  <select className="nrf-input" value={newType} onChange={e => setNewType(e.target.value)}>
                    <option value="">{t('requests.formTypeSelect')}</option>
                    {reqTypes.map(rt => <option key={rt.id} value={rt.id}>{lang === 'en' ? (rt.name_en || rt.name) : rt.name}</option>)}
                  </select>
                </>
              )}

              {isPublicationType && (
                <div className="nrf-extra-fields" style={{'--accent': '#7c3aed'}}>
                  <div className="nrf-extra-title">{t('publication.title')}</div>
                  <div className="pub-warning">
                    <span className="pub-warning-icon"><Icon name="warning" size={16} /></span>
                    <span>{t('publication.warning2Days')}</span>
                  </div>
                  <label className="nrf-label">{t('publication.fieldDate')}</label>
                  <input type="date" className="nrf-input" min={minPubDate}
                    value={newPubDate} onChange={e => setNewPubDate(e.target.value)} required />
                  <label className="nrf-label">{t('publication.fieldMaterial')}</label>
                  <label className="pub-file-drop">
                    <input type="file" accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.zip" style={{display:'none'}}
                      onChange={e => handlePubFileUpload(e.target.files[0])} />
                    <span className="pub-file-icon">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17,8 12,3 7,8"/><line x1="12" y1="3" x2="12" y2="15"/>
                      </svg>
                    </span>
                    {newPubUploading ? (
                      <span className="pub-file-text">{t('publication.uploading')}</span>
                    ) : newPubFile ? (
                      <span className="pub-file-text pub-file-uploaded">
                        <Icon name="check" size={13} /> {newPubFile.name} <small>({Math.round(newPubFile.size/1024)} KB)</small>
                      </span>
                    ) : (
                      <>
                        <span className="pub-file-text">{t('publication.browseHint')}</span>
                        <span className="pub-file-formats">{t('publication.formats')}</span>
                      </>
                    )}
                  </label>
                </div>
              )}

              {isLegal && (
                <div className="nrf-extra-fields nrf-legal" style={{'--accent': deptColor}}>
                  <div className="nrf-form-badge">{t('legal.formNo')}</div>
                  <div className="nrf-extra-title">{t('legal.title')}</div>
                  <p className="nrf-form-note">{t('legal.subtitle')}</p>

                  {/* 1. Sorğu göndərən (MTK nümayəndəsi) */}
                  <div className="nrf-sec">{t('legal.sec1')}</div>
                  <label className="nrf-label">{t('legal.fieldRequester')}<span style={{color:'#dc2626'}}> *</span></label>
                  <input className="nrf-input" value={lgRequester} onChange={e => setLgRequester(e.target.value)}
                    placeholder={t('legal.phRequester')} required />
                  <label className="nrf-label">{t('legal.fieldPosition')}</label>
                  <input className="nrf-input" value={lgPosition} onChange={e => setLgPosition(e.target.value)}
                    placeholder={t('legal.phPosition')} />

                  {/* 2. Müqavilənin bağlanıldığı digər tərəf */}
                  <div className="nrf-sec">{t('legal.sec2')}</div>
                  <label className="nrf-label">{t('legal.fieldParty')}<span style={{color:'#dc2626'}}> *</span></label>
                  <input className="nrf-input" value={lgParty} onChange={e => setLgParty(e.target.value)}
                    placeholder={t('legal.phParty')} required />
                  <label className="nrf-label">{t('legal.fieldContact')}</label>
                  <input className="nrf-input" value={lgContact} onChange={e => setLgContact(e.target.value)}
                    placeholder={t('legal.phContact')} />
                  <div className="nrf-row2">
                    <div>
                      <label className="nrf-label">{t('legal.fieldPhone')}</label>
                      <input className="nrf-input" type="tel" value={lgPhone} onChange={e => setLgPhone(e.target.value)}
                        placeholder="+994 __ ___ __ __" />
                    </div>
                    <div>
                      <label className="nrf-label">{t('legal.fieldEmail')}</label>
                      <input className="nrf-input" type="email" value={lgEmail} onChange={e => setLgEmail(e.target.value)}
                        placeholder="nümunə@domain.com" />
                    </div>
                  </div>

                  {/* 3. Müqavilənin şərtləri */}
                  <div className="nrf-sec">{t('legal.sec3')}</div>
                  <label className="nrf-label">{t('legal.fieldSubject')}<span style={{color:'#dc2626'}}> *</span></label>
                  <textarea className="nrf-input" rows={2} value={lgSubject} onChange={e => setLgSubject(e.target.value)}
                    placeholder={t('legal.phSubject')} required />
                  <label className="nrf-label">{t('legal.fieldPrice')}<span style={{color:'#dc2626'}}> *</span></label>
                  <textarea className="nrf-input" rows={2} value={lgPrice} onChange={e => setLgPrice(e.target.value)}
                    placeholder={t('legal.phPrice')} required />
                  <div className="nrf-row2">
                    <div>
                      <label className="nrf-label">{t('legal.fieldStart')}</label>
                      <input className="nrf-input" type="date" value={lgStart} onChange={e => setLgStart(e.target.value)} />
                    </div>
                    <div>
                      <label className="nrf-label">{t('legal.fieldDuration')}</label>
                      <input className="nrf-input" value={lgDuration} onChange={e => setLgDuration(e.target.value)}
                        placeholder={t('legal.phDuration')} />
                    </div>
                  </div>
                  <label className="nrf-label">{t('legal.fieldSpecial')}</label>
                  <textarea className="nrf-input" rows={2} value={lgSpecial} onChange={e => setLgSpecial(e.target.value)}
                    placeholder={t('legal.phSpecial')} />

                  {/* 4. Təsdiq imzaları — formada sabitdir */}
                  <div className="nrf-sec">{t('legal.sec4')}</div>
                  <div className="nrf-signs">
                    <div><span>{t('legal.signDirector')}</span><b>Tural Abbasov</b></div>
                    <div><span>{t('legal.signFinance')}</span><b>Mehman Babayev</b></div>
                    <div><span>{t('legal.signRequester')}</span><b>{lgRequester || '—'}</b></div>
                  </div>
                  <p className="nrf-form-note">{t('legal.signNote')}</p>
                </div>
              )}

              {isMaintenance && (
                <div className="nrf-extra-fields" style={{'--accent': deptColor}}>
                  <div className="nrf-extra-title">{t('maintenance.title')}</div>
                  <label className="nrf-label">{t('maintenance.fieldLocation')}<span style={{color:'#dc2626'}}> *</span></label>
                  <input className="nrf-input" value={maintLocation} onChange={e => setMaintLocation(e.target.value)}
                    placeholder={t('maintenance.fieldLocationPlaceholder')} required />
                  <label className="nrf-label">{t('maintenance.fieldRoom')}</label>
                  <input className="nrf-input" value={maintRoom} onChange={e => setMaintRoom(e.target.value)}
                    placeholder={t('maintenance.fieldRoomPlaceholder')} />
                  <label className="nrf-label">{t('maintenance.fieldAccess')}</label>
                  <select className="nrf-input" value={maintAccess} onChange={e => setMaintAccess(e.target.value)}>
                    <option value="anytime">{t('maintenance.accessAnytime')}</option>
                    <option value="morning">{t('maintenance.accessMorning')}</option>
                    <option value="afternoon">{t('maintenance.accessAfternoon')}</option>
                    <option value="afterhours">{t('maintenance.accessAfterHours')}</option>
                  </select>
                  <label className="nrf-label">{t('maintenance.fieldPhoto')}</label>
                  <label className="pub-file-drop">
                    <input type="file" accept="image/*,.pdf" style={{display:'none'}}
                      onChange={e => handleMaintPhotoUpload(e.target.files[0])} />
                    <span className="pub-file-icon">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/>
                      </svg>
                    </span>
                    {maintPhotoUploading ? (
                      <span className="pub-file-text">{t('maintenance.uploading')}</span>
                    ) : maintPhotoName ? (
                      <span className="pub-file-text pub-file-uploaded">
                        <Icon name="check" size={13} /> {maintPhotoName}
                      </span>
                    ) : (
                      <>
                        <span className="pub-file-text">{t('maintenance.photoHint')}</span>
                        <span className="pub-file-formats">{t('maintenance.photoFormats')}</span>
                      </>
                    )}
                  </label>
                </div>
              )}

              {isIT && !isPublicationType && (
                <div className="nrf-extra-fields" style={{'--accent': deptColor}}>
                  <div className="nrf-extra-title">{t('requests.formITInfoTitle')}</div>
                  <label className="nrf-label">{t('requests.formCategory')}</label>
                  <select className="nrf-input" value={newCategory} onChange={e => setNewCategory(e.target.value)}>
                    <option value="">{t('requests.formCategorySelect')}</option>
                    {IT_CATEGORIES.map(c => <option key={c.v} value={c.v}>{c.l}</option>)}
                  </select>
                  <label className="nrf-label">{t('requests.formRoom')}</label>
                  <OtaqSecici value={newRoom} onChange={setNewRoom}
                              placeholder={t('requests.formRoomSelect')} />
                  <label className="nrf-label">{t('requests.formDevice')}</label>
                  <input className="nrf-input" value={newDevice} onChange={e => setNewDevice(e.target.value)} placeholder={t('requests.formDevicePlaceholder')} />
                  <label className="nrf-label">{t('requests.formOS')}</label>
                  <select className="nrf-input" value={newOS} onChange={e => setNewOS(e.target.value)}>
                    <option value="">{t('requests.formOSSelect')}</option>
                    {IT_OS.map(o => <option key={o} value={o}>{o}</option>)}
                  </select>
                  <label className="nrf-label">{t('requests.formErrorMsg')}</label>
                  <textarea className="nrf-input" value={newErrorMsg} onChange={e => setNewErrorMsg(e.target.value)} rows={2} placeholder={t('requests.formErrorMsgPlaceholder')} />
                </div>
              )}

              {isFinance && (
                <div className="nrf-extra-fields" style={{'--accent': deptColor}}>
                  <div className="nrf-extra-title">Maliyyə Məlumatları</div>
                  {reqTypes.find(rt => rt.id === parseInt(newType) && rt.name.includes('hissə-hissə')) && (
                    <>
                      <label className="nrf-label">Ödəmə müddəti *</label>
                      <div style={{ display:'flex', gap:8 }}>
                        {[3,6,12].map(m => (
                          <label key={m} className={'nrf-type-card small' + (newInstallMonths===String(m)?' sel':'')} style={{'--sel-color': deptColor}}>
                            <input type="radio" style={{display:'none'}} checked={newInstallMonths===String(m)} onChange={() => setNewInstallMonths(String(m))} />
                            <span className="nrf-type-name">{m} ay</span>
                          </label>
                        ))}
                      </div>
                    </>
                  )}
                  {reqTypes.find(rt => rt.id === parseInt(newType) && rt.name.includes('pay slip')) && (
                    <>
                      <label className="nrf-label">Hansı ay üçün? *</label>
                      <input type="month" className="nrf-input" value={newPaySlipMonth} onChange={e => setNewPaySlipMonth(e.target.value)} />
                    </>
                  )}
                </div>
              )}

              <label className="nrf-label">{t('requests.formTitle')}</label>
              <input className="nrf-input" value={newTitle} onChange={e => setNewTitle(e.target.value)} required
                placeholder={t('requests.formTitlePlaceholder')} />

              <label className="nrf-label">{isFinance ? t('procurement.additionalNote') : t('requests.formDetail')}</label>
              <textarea className="nrf-input" value={newDesc} onChange={e => setNewDesc(e.target.value)} rows={4}
                placeholder={isFinance ? t('procurement.additionalNotePlaceholder') : t('requests.formDetailPlaceholder')} />

              {!isFinance && !isLegal && (
                <>
                  <label className="nrf-label">{t('requests.formPriority')}</label>
                  <div className="nrf-priority-grid">
                    {Object.entries(PRIORITY).map(([k,v]) => (
                      <label key={k} className={'nrf-priority-opt' + (newPriority === k ? ' sel' : '')}>
                        <input type="radio" name="priority" value={k} checked={newPriority === k} onChange={() => setNewPriority(k)} style={{display:'none'}} />
                        <span style={{ color: v.color, fontWeight:700, fontSize:'0.82rem' }}>&#9650; {v.label}</span>
                        <small>{v.sla}</small>
                      </label>
                    ))}
                  </div>
                </>
              )}
            </>
          )}

          <div className="nrf-actions">
            <button type="button" className="nrf-btn-cancel" onClick={handleBack}>{t('requests.btnCancel')}</button>
            <button type="submit" className="nrf-btn-submit" disabled={submitting} style={{background: deptColor}}>
              {submitting ? t('common.saving') : t('requests.btnSubmit')}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}
